import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { Box } from "@mui/system";
import Typography from "@mui/material/Typography";
import rv_logo from "./static/RVWeather.svg";
import { logoHeight, logoWidth } from "./components/risk/geoUtils";
import { useIsMobile } from "./features/pageWidth/pageWidthSlice";

const LoadingSpinner = () =>
{
    const isMobile = useIsMobile( );
    return (
        <Backdrop
            sx = {{ color: "#fff", zIndex: ( theme ) => theme.zIndex.drawer + 1 }}
            open
        >
            <Box sx = {{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <Box
                    component = "img"
                    alt = "rvwx logo"
                    src = {rv_logo}
                    sx = {{
                        height: isMobile ? logoHeight / 2 : logoHeight,
                        width: isMobile ? logoWidth / 2 : logoWidth,
                        maxHeight: logoHeight,
                        maxWidth: logoWidth,
                    }}
                />
                <CircularProgress color = "inherit" size = {60}/>
                <Typography variant = "h6" sx = {{ mt: 2 }}>
                    Loading...
                </Typography>
            </Box>
        </Backdrop>
    );
};

export default LoadingSpinner;
